module.exports = {
    // 更新个人数据
    UpdateLadderMyBaseInfo: "UpdateLadderMyBaseInfo",

    // 更新全部挑战对手数据
    UpdateAllLadderEnemyList: "UpdateAllLadderEnemyList",

    // 对手信息
    GetLadderEnemyData: "GetLadderEnemyData",

    // 前三名数据
    UpdateLadderTopThreeRoleData: "UpdateLadderTopThreeRoleData",

    // 排行榜数据
    UpdateLadderRankData: "UpdateLadderRankData",

    // 我的记录
    UpdateLadderMyLogData: "UpdateLadderMyLogData",

    // 大神风采
    UpdateLadderGodLogData: "UpdateLadderGodLogData",

    // 天梯状态改变
    UpdateLadderOpenStatus: "UpdateLadderOpenStatus",

    // 天梯红点改变
    UpdateLadderRedStatus: "UpdateLadderRedStatus"
}

